import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const CdiPageForNro = lazy(() =>
  import("@technology-partners/cdi-import-sync-shared/CdiPage/CdiPageForNro").then((module) => ({
    default: module.CdiPageForNro,
  }))
);

export const cloudDataIngestionNRO: NavigationRoutingObject = {
  Component: CdiPageForNro,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "data-settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("cdi-menu-option", "Cloud Data Ingestion"),
  pageNameForTracking: () => "Cloud Data Ingestion",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("cdi-description-nav", "Import data directly from cloud data warehouses"),
  icon: "nav-system-cloud-data-ingestion",
  featureLimitationKeys: ["can_only_view_landing_page_cdi"],
  getDeveloperNavigationAllowed: () => {
    return true;
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [
        t("cdi-alt-keyword-1", "import sync"),
        t("cdi-alt-keyword-2", "data sync"),
        t("cdi-alt-keyword-3", "data access management"),
        t("cdi-alt-keyword-4", "sync log"),
        t("cdi-alt-keyword-5", "cdi"),
      ],
    },
  ],
  additionalSearchableFeatures: () => ({}),
};
